import { SET_REPORT_DATA, REPORT_DATA_ADDED, ORG_DATA } from './actions';

const initialState = {
     reportData: '',
     title: ''
};

const reportData = (state = initialState, action) => {
     switch (action.type) {
          case SET_REPORT_DATA:
               return { ...state, reportData: action.payload, title: action.payload };
          default:
               return state;
     }
};

const reportDataAdded = (state = {} , action) => {
     switch (action.type) {
          case REPORT_DATA_ADDED:
               return { ...state, reportData: action.payload };
          default:
               return state;
     }
}

// const orgData = (state = {}, action) => {
//      switch (action.type) {
//           case ORG_DATA:
//                return { ...state, orgData: action.payload };
//           default:
//                return state;
//      }
// }


export default {reportData, reportDataAdded};